<template>
  <div class="popup-container" :class="{ active }">
    <div v-clickout.stop="() => (active ? popupResolve(false) : false)" class="content popup">
      <div class="close" @click.stop="() => (active ? popupResolve(false) : false)" />
      <component :is="popupType" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Archive from './Archive';
import ChangeMonitoring from './ChangeMonitoring';
import Confirm from './Confirm';
import DisableMonitoringLevel from './DisableMonitoringLevel';
import DisablePackage from './DisablePackage';
import DisableUser from './DisableUser';
import EnableUser from './EnableUser';
import HaveToMonitor from './HaveToMonitor';
import SetUpMonitoring from './SetUpMonitoring';

export default {
  components: { DisableMonitoringLevel, ChangeMonitoring, Archive, DisableUser, EnableUser, Confirm, HaveToMonitor, SetUpMonitoring, DisablePackage },

  data() {
    return {
      active: false,
    };
  },

  computed: {
    ...mapGetters(['user', 'popupType', 'popupResolve']),
  },

  watch: {
    popupType(newValue) {
      this.selectScroll(newValue);
    },
  },

  methods: {
    enableScroll() {
      document.querySelector('body').style.overflow = 'visible';
    },

    disableScroll() {
      document.querySelector('body').style.overflow = 'hidden';
    },

    selectScroll(value) {
      if (!value) this.enableScroll();
      else this.disableScroll();
      this.active = !!value;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
@use '@/styles/variables.scss';
.popup-container {
  position: fixed;
  top: 50%;
  bottom: 50%;
  right: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 102;
  opacity: 0;
  transition: all 0.15s;

  .popup {
    transition: all 0.15s;
    width: 0;
    height: 0;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &.active {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(colors.$black-color, 0.3);
    opacity: 1;

    .close {
      position: absolute;
      right: 8px;
      top: 12px;
      width: 24px;
      height: 24px;
      transition: all 0.2s;

      &:after {
        top: 0;
        right: 0;
        position: absolute;
        content: '';
        width: 12px;
        height: 2px;
        background: colors.$lightgrey-color;
        transition: all 0.2s;
        transform: rotate(45deg);
      }

      &:before {
        top: 0;
        right: 0;
        position: absolute;
        content: '';
        width: 12px;
        height: 2px;
        background: colors.$lightgrey-color;
        border-radius: 4px;
        transition: all 0.2s;
        transform: rotate(-45deg);
      }

      &:hover {
        &:before,
        &:after {
          background: colors.$grey-color;
          cursor: pointer;
        }
      }
    }

    .popup {
      position: relative;
      box-sizing: border-box;
      padding: 60px 100px;
      width: auto;
      opacity: 1;
      min-height: 280px;
      height: fit-content;
      max-height: calc(100vh - 256px);
      min-width: 590px;
      background: colors.$white-color;
      border-radius: 8px;
      box-shadow: 0 4px 32px variables.$box-shadow;
      border: solid 1px colors.$lightgrey-color;
    }
  }
}
</style>
